import { Navigate, Outlet, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { ChainId } from "@KassaroAB/shared/types/ids";
import { LoadingContainer } from "../../components/LoadingContainer";
import { useGetChainQuery } from "../../query/chainsQuery";

export const ChainModeGuard = () => {
  const { t } = useTranslation();
  const { chainId } = useParams<{ chainId: ChainId }>();
  const { data: chain, isLoading } = useGetChainQuery(chainId);

  if (!chainId) {
    return null;
  }

  if (isLoading) {
    return <LoadingContainer message={t("common.loading")} />;
  }

  if (chain?.chainMode !== true) {
    return <Navigate to={`/chains/${chainId}/overview`} replace />;
  }

  return <Outlet />;
};
